(() => {
  'use strict';
  for (const root of document.querySelectorAll('[data-f2w-country-sport]')) {
    if (root.dataset.initialized) continue;
    root.dataset.initialized = 'true';
    const countryId = root.dataset.countryId;
    const sportId = root.dataset.sportId;
    const countFormatter = new Intl.NumberFormat(root.dataset.language || 'nl');
    const formatCount = value => countFormatter.format(value);
    const perPage = 24;
    const resultText = (element, count) => `${formatCount(count)} ${element.dataset[count === 1 ? 'resultOne' : 'resultMany'] || root.dataset.verified}`;
    const groups = {gyms:'sports_location',fighters:'fighter_profile',trainers:'trainer_profile',organizations:'organization',events:'event',venues:'venue'};
    const indexTypes = {fighters:'fighter_profile',trainers:'trainer_profile',organizations:'organization',events:'event',venues:'venue'};
    const sections = Object.fromEntries(Object.keys(groups).map(key => [key,root.querySelector(`[data-country-sport-section="${key}"]`)]));
    const navigation = root.querySelector('[data-country-sport-chapters]');
    const chapterSections = Array.from(root.querySelectorAll('[data-f2w-country-chapter]'));
    const chaptersByName = Object.fromEntries(chapterSections.map(section => [section.dataset.f2wCountryChapter,section]));
    const parse = selector => {
      const el = root.querySelector(selector);
      if (!el) throw new Error('Missing verified geographic index');
      return JSON.parse(el.textContent);
    };
    let countryParts, gymParts, indexError = null;
    try {
      countryParts = parse('[data-country-buckets]');
      gymParts = parse('[data-gym-buckets]');
    } catch (error) {
      console.warn('FightBase Country Sport:', error);
      indexError = error;
    }
    const merge = (parts, type) => {
      const buckets = Array.isArray(parts) ? parts : [parts];
      if (buckets.some(item => item !== null && (typeof item !== 'object' || Array.isArray(item)))) throw new Error('Invalid index bucket');
      if (type === 'gym') {
        if (buckets.some(item => item !== null && !Array.isArray(item.r))) throw new Error('Invalid Gym bucket');
        return buckets.flatMap(item => item?.r || []);
      }
      return buckets.flatMap(item => item?.[type] || []);
    };
    const candidateIds = group => {
      if (indexError) throw indexError;
      return [...new Set((group === 'gyms' ? merge(gymParts,'gym').filter(row => ['gym','school','dojo','dojang'].includes(String(row?.[1] || '').toLowerCase())) : merge(countryParts,indexTypes[group]))
        .map(row => row?.[0]).filter(id => typeof id === 'string' && id.startsWith('gid://shopify/Metaobject/')))];
    };
    const query = `query CountrySport($ids:[ID!]!,$language:LanguageCode!) @inContext(language:$language) {
      nodes(ids:$ids) { ... on Metaobject { id type onlineStoreUrl
        name:field(key:"name"){value} displayName:field(key:"display_name"){value} nickname:field(key:"nickname"){value}
        image:field(key:"resolved_image_url"){value} intro:field(key:"intro"){value}
        dateStart:field(key:"date_start"){value} dateEnd:field(key:"date_end"){value}
        isHistoric:field(key:"is_historic"){value} city:field(key:"city"){value}
        birthCity:field(key:"birth_city"){reference{... on Metaobject{id name:field(key:"name"){value}}}}
        headquartersCity:field(key:"headquarters_city"){reference{... on Metaobject{id name:field(key:"name"){value}}}}
        sports:field(key:"sports"){references(first:250){nodes{... on Metaobject{id}} pageInfo{hasNextPage}}}
      }} }`;
    const eventQuery = `query CountrySportEvents($ids:[ID!]!,$language:LanguageCode!) @inContext(language:$language) {
      nodes(ids:$ids) { ... on Metaobject { id type handle onlineStoreUrl fields { key value } } }
    }`;
    const eventReferencesQuery = `query CountrySportEventReferences($ids:[ID!]!,$language:LanguageCode!) @inContext(language:$language) {
      nodes(ids:$ids) {
        __typename
        ... on Metaobject { id handle fields { key value } }
        ... on MediaImage { id image { url } }
      }
    }`;
    const endpoint = `https://${root.dataset.domain}/api/2024-10/graphql.json`;
    const language = (root.dataset.language || 'nl').split('-')[0].toUpperCase();
    const token = root.dataset.token;
    const name = node => (typeof node.name === 'string' ? node.name : node.name?.value) || node.displayName?.value || '';
    const normalize = value => String(value || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase(root.dataset.language || 'nl').replace(/\s+/g, ' ').trim();
    const cityName = (node,group) => {
      if (group === 'fighters' || group === 'trainers') return String(node.birthCity?.reference?.name?.value || '').trim();
      if (group === 'organizations') return String(node.headquartersCity?.reference?.name?.value || '').trim();
      if (group === 'events') return String(node.city || '').trim();
      return String(node.city?.value || '').trim();
    };
    const route = url => {
      if (!url) return '';
      try {
        const parsed = new URL(url, location.origin);
        if (!['http:','https:'].includes(parsed.protocol)) return '';
        let path = parsed.pathname.replace(/^\/[a-z]{2}(?=\/|$)/i,'');
        const prefix = (window.Shopify?.routes?.root || '/').replace(/\/$/,'');
        if (prefix && path.startsWith(`${prefix}/`)) path = path.slice(prefix.length);
        return `${prefix}${path}${parsed.search}${parsed.hash}`;
      } catch (_) { return ''; }
    };
    const make = (tag,className,text) => {
      const el = document.createElement(tag);
      if (className) el.className = className;
      if (text != null) el.textContent = text;
      return el;
    };
    async function requestNodes(ids,requestQuery,batchSize = 100,requireComplete = true) {
      if (!token || !endpoint) throw new Error('Missing Storefront settings');
      const output = [];
      for (let start = 0; start < ids.length; start += batchSize) {
        const selected = ids.slice(start,start + batchSize);
        const response = await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':token},body:JSON.stringify({query:requestQuery,variables:{ids:selected,language}})});
        if (!response.ok) throw new Error('Storefront request failed');
        const data = await response.json();
        if (data.errors?.length || !Array.isArray(data.data?.nodes) || (requireComplete && data.data.nodes.length !== selected.length)) throw new Error('Storefront response incomplete');
        output.push(...data.data.nodes.filter(Boolean));
      }
      return output;
    }
    async function getNodes(ids) {
      return requestNodes(ids,query,100,true);
    }
    const fieldMap = fields => (fields || []).reduce((map,field) => {
      map[field.key] = field.value;
      return map;
    },{});
    const parseReferenceIds = value => {
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) return parsed.filter(Boolean);
        if (typeof parsed === 'string') return [parsed];
      } catch (_) {}
      return String(value).split(',').map(item => item.trim()).filter(Boolean);
    };
    const referenceName = (id,references) => {
      const reference = references.get(id);
      if (!reference) return '';
      const fields = fieldMap(reference.fields);
      return fields.name || fields.title || reference.handle || '';
    };
    const referenceNames = (value,references) => parseReferenceIds(value).map(id => referenceName(id,references)).filter(Boolean);
    const referenceOrValue = (value,references) => {
      const text = String(value || '').trim();
      const resolved = parseReferenceIds(value).map(id => referenceName(id,references)).find(Boolean);
      if (resolved) return resolved;
      if (/^gid:\/\/shopify\/Metaobject\//.test(text) || text.startsWith('[')) return '';
      return text;
    };
    const referenceCode = (value,references) => {
      const id = parseReferenceIds(value)[0];
      return id ? fieldMap(references.get(id)?.fields).code || '' : '';
    };
    const parseDate = value => {
      const match = String(value || '').match(/^\d{4}-\d{2}-\d{2}/);
      return match ? match[0] : '';
    };
    const parseBoolean = value => ['true','1','yes'].includes(normalize(value));
    async function getEventNodes(ids) {
      const events = await requestNodes(ids,eventQuery,100,true);
      const referenceIds = new Set();
      const referenceFields = ['country','sports','fighters','organization','location_name','venue','city_reference'];
      for (const event of events) {
        const fields = fieldMap(event.fields);
        for (const key of referenceFields) {
          for (const id of parseReferenceIds(fields[key])) {
            if (typeof id === 'string' && id.startsWith('gid://shopify/Metaobject/')) referenceIds.add(id);
          }
        }
      }
      const referenceNodes = await requestNodes([...referenceIds],eventReferencesQuery,250,false);
      const references = new Map(referenceNodes.filter(node => node?.id).map(node => [node.id,node]));
      return events.map(event => {
        const fields = fieldMap(event.fields);
        const sports = [...new Set(referenceNames(fields.sports,references))].sort((a,b) => a.localeCompare(b,root.dataset.language || 'nl'));
        const dateStart = parseDate(fields.date_start);
        const dateEnd = parseDate(fields.date_end);
        return {
          id:event.id,
          type:event.type,
          handle:event.handle,
          onlineStoreUrl:event.onlineStoreUrl || '',
          name:fields.name || event.handle || 'Event',
          image:fields.resolved_image_url || '',
          dateStart,
          dateEnd,
          city:fieldMap(references.get(parseReferenceIds(fields.city_reference)[0])?.fields).name || '',
          location:referenceOrValue(fields.location_name,references) || referenceOrValue(fields.venue,references),
          country:referenceNames(fields.country,references)[0] || '',
          countryCode:referenceCode(fields.country,references),
          sports,
          sportIds:parseReferenceIds(fields.sports),
          organization:referenceNames(fields.organization,references)[0] || '',
          isHistoric:fields.is_historic || '',
          status:normalize(fields.status)
        };
      });
    }
    function matched(node,group) {
      if (group === 'events') {
        if (node.type !== 'event' || !route(node.onlineStoreUrl)) return false;
        if (!Array.isArray(node.sportIds) || !node.sportIds.includes(sportId)) return false;
        if (parseBoolean(node.isHistoric)) return false;
        const date = (node.dateEnd || node.dateStart || '').slice(0,10);
        return /^\d{4}-\d{2}-\d{2}$/.test(date);
      }
      if (node.type !== groups[group] || !route(node.onlineStoreUrl)) return false;
      const sportsField = node.sports;
      if (!sportsField) return false;
      const sports = sportsField.references;
      if (!sports || !Array.isArray(sports.nodes) || !sports.pageInfo || sports.pageInfo.hasNextPage) {
        throw new Error('Incomplete Sport relation');
      }
      return sports.nodes.some(s => s.id === sportId);
    }
    function createCountryFlag(code,label) {
      const flagCode = String(code || '').trim().toLowerCase();
      if (!(flagCode.length === 2 || ['gb-sct','gb-eng','gb-wls'].includes(flagCode))) return null;
      const wrapper = make('span','f2w-country-flag');
      const image = make('img');
      image.src = `https://flagcdn.com/w40/${flagCode}.png`;
      image.srcset = `https://flagcdn.com/w80/${flagCode}.png 2x`;
      image.alt = label || '';
      image.width = 20;
      image.height = 15;
      image.loading = 'lazy';
      wrapper.append(image);
      return wrapper;
    }
    function eventCard(event) {
      const article = make('article','f2w-event-card');
      article.dataset.f2wEventCard = 'true';
      article.dataset.date = event.dateStart || '';
      const link = make('a','f2w-event-card__link');
      link.href = route(event.onlineStoreUrl);
      const media = make('div','f2w-event-card__image');
      if (event.image) {
        const img = make('img'); img.src = event.image; img.alt = event.name; img.width = 1100; img.loading = 'lazy'; img.decoding = 'async'; media.append(img);
      } else {
        const placeholder = make('div','f2w-event-card__image--placeholder');
        placeholder.append(make('span','',event.name.slice(0,1))); media.append(placeholder);
      }
      const body = make('div','f2w-event-card__body');
      const dateBlock = make('div','f2w-event-card__date-block');
      const date = event.dateStart ? new Date(`${event.dateStart}T12:00:00Z`) : null;
      const month = date ? date.toLocaleDateString(root.dataset.language || 'nl-NL',{month:'short',timeZone:'UTC'}) : '—';
      dateBlock.append(
        make('span','f2w-event-card__date-day',event.dateStart ? event.dateStart.slice(8,10) : '—'),
        make('span','f2w-event-card__date-month',month),
        make('span','f2w-event-card__date-year',event.dateStart ? event.dateStart.slice(0,4) : '')
      );
      const content = make('div','f2w-event-card__content');
      if (event.organization) {
        const topline = make('div','f2w-event-card__topline');
        topline.append(make('span','f2w-event-card__period f2w-event-card__period--upcoming',event.organization));
        content.append(topline);
      }
      content.append(make('h2','f2w-event-card__title',event.name));
      if (event.dateEnd && event.dateEnd !== event.dateStart) {
        const untilLabel = String(root.dataset.eventUntil || '').trim();
        const endDate = event.dateEnd.split('-').reverse().join('-');
        content.append(make('p','f2w-event-card__date-range',[untilLabel,endDate].filter(Boolean).join(' ')));
      }
      const location = [event.location,event.city].filter(Boolean).join(', ');
      if (location) content.append(make('p','f2w-event-card__location',location));
      if (event.country) {
        const countryLine = make('p','f2w-event-card__location f2w-country-line');
        const flag = createCountryFlag(event.countryCode,event.country);
        if (flag) countryLine.append(flag,document.createTextNode(' '));
        countryLine.append(document.createTextNode(event.country));
        content.append(countryLine);
      }
      if (event.sports.length) {
        const sports = make('div','f2w-event-card__sports');
        event.sports.forEach(sport => sports.append(make('span','f2w-event-card__sport',sport)));
        content.append(sports);
      }
      if (root.dataset.eventView) content.append(make('span','f2w-event-card__view',root.dataset.eventView));
      body.append(dateBlock,content);
      link.append(media,body);
      article.append(link);
      return article;
    }
    function card(node,group) {
      if (group === 'events') return eventCard(node);
      const article = make('article','f2w-event-card');
      const link = make('a','f2w-event-card__link');
      link.href = route(node.onlineStoreUrl);
      const media = make('div','f2w-event-card__image');
      if (node.image?.value) {
        const img = make('img'); img.src = node.image.value; img.alt = name(node); img.width = 900; img.height = 675; img.loading = 'lazy'; img.decoding = 'async'; media.append(img);
      } else {
        const placeholder = make('div','f2w-event-card__image--placeholder');
        placeholder.append(make('span','',name(node).slice(0,1))); media.append(placeholder);
      }
      const body = make('div','f2w-event-card__body');
      const content = make('div','f2w-event-card__content');
      if (node.nickname?.value) {
        const topline = make('div','f2w-event-card__topline');
        topline.append(make('span','f2w-event-card__period f2w-event-card__period--upcoming',node.nickname.value));
        content.append(topline);
      }
      content.append(make('h2','f2w-event-card__title',name(node)));
      content.append(make('span','f2w-event-card__view',root.dataset.view));
      body.append(content); link.append(media,body); article.append(link); return article;
    }
    let active = '';
    const state = Object.fromEntries(Object.keys(groups).map(key => [key,{loaded:false,promise:null,records:[],page:1,city:'',search:''}]));
    const filterControls = Object.fromEntries(Object.keys(groups).map(group => {
      const section = sections[group];
      return [group,{
        cityGroup:section?.querySelector('[data-country-sport-city-filter]'),
        cityLabel:section?.querySelector('[data-country-sport-city-label]'),
        cityChoices:section?.querySelector('[data-country-sport-city-choices]'),
        searchPanel:section?.querySelector('[data-country-sport-search-panel]'),
        searchWrap:section?.querySelector('[data-country-sport-search-filter]'),
        searchInput:section?.querySelector('[data-country-sport-search]')
      }];
    }));
    const counterNodes = Object.fromEntries(['gyms','fighters'].map(group => [group,root.querySelector(`[data-country-sport-count="${group}"]`)]));
    function indexedCounts() {
      const source = root.querySelector('[data-sport-country-counts]');
      const handle = root.dataset.sportHandle;
      if (!source || !handle) return null;
      try {
        const payload = JSON.parse(source.textContent);
        if (payload.slots?.[0] !== 'gyms' || payload.slots?.[1] !== 'fighters' || !Array.isArray(payload.buckets)) return null;
        let foundCountry = false;
        let foundAll = false;
        const totals = [0,0];
        const allTotals = [0,0];
        for (const bucket of payload.buckets) {
          if (bucket == null) continue;
          if (typeof bucket !== 'object' || Array.isArray(bucket)) return null;
          foundCountry = true;
          const all = bucket.__all_sports__;
          if (all != null) {
            if (!Array.isArray(all) || all.length !== payload.slots.length || !all.every(value => Number.isInteger(value) && value >= 0)) return null;
            foundAll = true;
            allTotals[0] += all[0];
            allTotals[1] += all[1];
          }
          const values = bucket[handle];
          if (values == null) continue;
          if (!Array.isArray(values) || values.length !== payload.slots.length || !values.every(value => Number.isInteger(value) && value >= 0)) return null;
          totals[0] += values[0];
          totals[1] += values[1];
        }
        if (!foundCountry || !foundAll || totals.some((value,i) => value > allTotals[i])) return null;
        return {gyms:totals[0],fighters:totals[1]};
      } catch (error) {
        console.warn('FightBase Country Sport counts unavailable:',error);
        return null;
      }
    }
    const publishedCounts = indexedCounts();
    if (publishedCounts) {
      for (const group of ['gyms','fighters']) {
        if (counterNodes[group]) counterNodes[group].textContent = formatCount(publishedCounts[group]);
      }
    }
    function cityOptions(group) {
      const counts = new Map();
      for (const node of state[group].records) {
        const label = cityName(node,group);
        const key = normalize(label);
        if (!key) continue;
        const current = counts.get(key);
        if (current) current.count += 1;
        else counts.set(key,{key,label,count:1});
      }
      return [...counts.values()].sort((a,b) => b.count - a.count || a.label.localeCompare(b.label,root.dataset.language || 'nl'));
    }
    function filteredRecords(group) {
      const current = state[group];
      const queryText = normalize(current.search);
      return current.records.filter(node => {
        const city = cityName(node,group);
        return (!current.city || normalize(city) === current.city) &&
          (!queryText || normalize([name(node),city].filter(Boolean).join(' ')).includes(queryText));
      });
    }
    function renderFilters(group) {
      const current = state[group], controls = filterControls[group];
      if (!controls?.cityGroup || !controls.cityChoices || !controls.searchPanel || !controls.searchWrap) return;
      const options = cityOptions(group);
      const hasCityFilter = options.length >= 2;
      controls.cityGroup.hidden = !hasCityFilter;
      if (hasCityFilter) {
        const label = group === 'fighters' || group === 'trainers' ? root.dataset.personCityLabel : root.dataset.cityLabel;
        controls.cityLabel.textContent = label || '';
        controls.cityChoices.setAttribute('aria-label',label || '');
        let selected = options.find(option => option.key === current.city);
        if (current.city && !selected) current.city = '';
        selected = options.find(option => option.key === current.city);
        const allCities = make('button','f2w-event-card__sport',root.dataset.allCitiesLabel || '');
        allCities.type = 'button';
        allCities.setAttribute('aria-pressed',String(!current.city));
        allCities.addEventListener('click',() => {
          current.city = '';
          current.page = 1;
          render(group);
          controls.cityChoices.querySelector('button[aria-pressed="true"]')?.focus({preventScroll:true});
        });
        const buttons = [allCities];
        const visibleOptions = selected ? [selected] : options;
        for (const option of visibleOptions) {
          const button = make('button','f2w-event-card__sport',option.label);
          button.type = 'button';
          button.setAttribute('aria-pressed',String(current.city === option.key));
          button.addEventListener('click',() => {
            current.city = option.key;
            current.page = 1;
            render(group);
            controls.cityChoices.querySelector('button[aria-pressed="true"]')?.focus({preventScroll:true});
          });
          buttons.push(button);
        }
        controls.cityChoices.replaceChildren(...buttons);
      } else {
        controls.cityChoices.replaceChildren();
      }
      const scopedCount = current.records.filter(node => !current.city || normalize(cityName(node,group)) === current.city).length;
      const showSearch = scopedCount > perPage || Boolean(current.search.trim());
      controls.searchWrap.hidden = !showSearch;
      controls.searchPanel.hidden = !showSearch;
    }
    function render(group) {
      const section = sections[group], current = state[group];
      const filtered = filteredRecords(group);
      renderFilters(group);
      const grid = section.querySelector('[data-country-sport-results]');
      const status = section.querySelector('[data-country-sport-status]');
      if (status) { if (!filtered.length) status.textContent = root.dataset.empty; status.hidden = filtered.length > 0; }
      grid.replaceChildren(...filtered.slice((current.page - 1)*perPage,current.page*perPage).map(node => card(node,group)));
      const total = section.querySelector('[data-country-sport-total]');
      total.textContent = resultText(total, filtered.length);
      const pagination = section.querySelector('[data-country-sport-pagination]');
      if (!pagination) return;
      const pages = Math.ceil(filtered.length/perPage);
      pagination.hidden = pages <= 1;
      const controls = [];
      const pageButton = (text,target,ariaLabel,active) => {
        const button = make('button','f2w-event-directory__tab',text);
        button.type = 'button';
        if (ariaLabel) button.setAttribute('aria-label',ariaLabel);
        if (active) button.setAttribute('aria-current','page');
        else button.addEventListener('click',() => {
          current.page = target;
          render(group);
          pagination.querySelector('[aria-current="page"]')?.focus({preventScroll:true});
          grid.scrollIntoView({behavior:'smooth',block:'start'});
        });
        return button;
      };
      if (pages > 1) {
        if (current.page > 1) controls.push(pageButton('◀',current.page - 1,root.dataset.previous,false));
        const pageNumbers = [...new Set([1,current.page - 1,current.page,current.page + 1,pages]
          .filter(page => page >= 1 && page <= pages))].sort((a,b) => a - b);
        let previous = 0;
        for (const page of pageNumbers) {
          if (page - previous > 1) controls.push(make('span','','…'));
          controls.push(pageButton(String(page),page,`${root.dataset.page} ${page}`,page === current.page));
          previous = page;
        }
        if (current.page < pages) controls.push(pageButton('▶',current.page + 1,root.dataset.next,false));
      }
      pagination.replaceChildren(...controls);
    }
    async function loadGroup(group) {
      const current = state[group];
      if (current.loaded) return current.records;
      if (current.promise) return current.promise;
      current.promise = (async() => {
        const ids = candidateIds(group);
        const nodes = group === 'events' ? await getEventNodes(ids) : await getNodes(ids);
        const matchedNodes = nodes.filter(node => matched(node,group));
        current.records = group === 'events'
          ? matchedNodes.sort((a,b) => {
            if (!a.dateStart && !b.dateStart) return 0;
            if (!a.dateStart) return 1;
            if (!b.dateStart) return -1;
            return a.dateStart.localeCompare(b.dateStart);
          })
          : matchedNodes.sort((a,b) => name(a).localeCompare(name(b),root.dataset.language || 'nl'));
        current.loaded = true;
        return current.records;
      })();
      try {
        return await current.promise;
      } finally {
        current.promise = null;
      }
    }
    async function activate(group) {
      const activeSection = chaptersByName[group];
      if (!activeSection) return;
      active = group;
      for (const section of chapterSections) section.hidden = section !== activeSection;
      for (const button of navigation.querySelectorAll('button')) button.setAttribute('aria-selected',button.dataset.group === group ? 'true':'false');
      if (!Object.prototype.hasOwnProperty.call(groups,group)) return;
      const section = sections[group], status = section?.querySelector('[data-country-sport-status]');
      if (!section || !status) return;
      try {
        const records = await loadGroup(group);
        if (!publishedCounts && counterNodes[group]) counterNodes[group].textContent = formatCount(records.length);
        if (active !== group) return;
        status.hidden = true;
        render(group);
        const button = navigation.querySelector(`[data-group="${group}"]`);
        if (!records.length) {
          if (button) button.hidden = true;
          const next = navigation.querySelector('button:not([hidden])');
          if (next) activate(next.dataset.group);
          else { section.hidden = false; status.textContent = root.dataset.empty; status.hidden = false; }
        }
      } catch (error) {
        console.warn('FightBase Country Sport:',error);
        if (active === group) { status.textContent = root.dataset.error; status.hidden = false; }
      }
    }
    for (const group of Object.keys(groups)) {
      const input = filterControls[group].searchInput;
      input?.addEventListener('input',() => {
        state[group].search = input.value;
        state[group].page = 1;
        if (state[group].loaded) render(group);
      });
    }
    if (!countryId || !sportId || !navigation || !chapterSections.length) continue;
    navigation.setAttribute('role','tablist');
    for (const section of chapterSections) {
      const group = section.dataset.f2wCountryChapter;
      if (!group) continue;
      section.setAttribute('role','tabpanel');
      const button = make('button','f2w-country-detail__chapter-tab',section.querySelector('h2')?.textContent || group);
      button.type = 'button'; button.dataset.group = group;
      button.setAttribute('role','tab');
      button.setAttribute('aria-selected','false');
      button.setAttribute('aria-controls',section.id);
      button.addEventListener('click',() => activate(group)); navigation.append(button);
    }
    for (const link of root.querySelectorAll('[data-country-sport-jump]')) {
      link.addEventListener('click',(event) => {
        const group = link.dataset.countrySportJump;
        const chapter = chaptersByName[group];
        if (!chapter) return;
        event.preventDefault();
        activate(group);
        chapter.scrollIntoView({behavior:'smooth',block:'start'});
      });
    }
    const first = navigation.querySelector('button:not([hidden])');
    if (first) activate(first.dataset.group);
    if (!publishedCounts) {
      for (const counter of Object.values(counterNodes)) if (counter) counter.textContent = '—';
    }
  }
})();









